import React, { createContext, useReducer } from 'react'

import { createActions } from './actions'
import { reducer, propsToState } from './reducer'

export const AstuteContext = createContext({})

export const AstuteProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, propsToState(props))
  const actionsWithDispatch = createActions(dispatch, state)

  return (
    <section>
      <AstuteContext.Provider value={{ state, actions: actionsWithDispatch }}>
        {props.children}
      </AstuteContext.Provider>
    </section>
  )
}
